<template>
    <DropdownSelect
        :options="options"
        :value="value"
        :placeholder="placeholder"
        @input="$emit('input', $event)">
    </DropdownSelect>
</template>

<script>
    // ForumDropdownSelect: stylizes the dropdown select input for the forum.

    import DropdownSelect from '../dropdown-select';

    export default {
        // See src/components/reusable/dropdown-select/index.vue for prop
        // details
        props: ['options', 'value', 'placeholder'],

        components: {
            DropdownSelect,
        },

        mounted() {
            this.$el.classList.add('forum-dropdown-select');
        },
    }
</script>

<style lang="scss">
    .forum-dropdown-select.dropdown-select {
        button {
            background: none;
            border-bottom: 3px solid #b0b0b0;
            padding: 0;

            &:focus {
                border-color: #33ccff;
                outline: none;
            }
        }
        .dropdown {
            position: absolute;
        }
    }
</style>



// WEBPACK FOOTER //
// dropdown-select.vue?75a7d70c